import { useCreate, useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import { FullScreenLoading } from "components/fullScreenLoading";
import { HistoryLodModal } from "components/historyLogModal";
import { IAttractionParticipantDetail } from "interfaces";
import { useState } from "react";
import {
  InformationSection,
  RegistrationInformationSection,
} from "./components/detail";
import Button from "components/button";
import { Link } from "react-router-dom";
import { PencilIcon } from "@heroicons/react/outline";
import { HistoryLogButton } from "components/historyLogButton";
import { isHaveActionPermission } from "utills/helpers";

export const AttractionParticipantDetail: React.FC = () => {
  const [openLogModal, setOpenLogModal] = useState<boolean>(false);
  const { mutate, isLoading: isSendingEmail } = useCreate();

  const parse = useParse();
  const { params } = parse();
  const { data, isFetching, isPreviousData, isLoading } =
    useOne<IAttractionParticipantDetail>({
      resource: "participant/attractions",
      id: params?.id,
      meta: {
        resource: "data",
      },
      queryOptions: {
        enabled: !!params?.id,
      } as any,
    });

  const participantDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="w-full flex flex-col items-center gap-y-3 sm:gap-y-4">
      <Breadcrumbs
        customPageLabel="Attraction participant detail"
        additionalLabel={
          <div className="flex gap-x-2.5">
            <div>
              <HistoryLogButton
                className="w-11 h-11"
                resource={`participant/attractions/${participantDetailData?.participant.id}/history`}
              />
            </div>
            {isHaveActionPermission("attractions", "participants", "edit") ? (
              <Link
                to={`/participants/attraction/${participantDetailData?.participant.id}/edit`}
              >
                <Button className="w-11 h-11 sm:w-auto">
                  <span className="sr-only">Edit</span>
                  <PencilIcon className="w-4 h-4 text-white" />{" "}
                  <span className="hidden sm:block sm:ml-2">Edit</span>
                </Button>
              </Link>
            ) : (
              <></>
            )}
          </div>
        }
      />
      {participantDetailData ? (
        <>
          <InformationSection participantDetailData={participantDetailData} />
          <RegistrationInformationSection
            participantDetailData={participantDetailData}
          />
        </>
      ) : (
        <></>
      )}

      {(isFetching && isPreviousData) || isSendingEmail ? (
        <FullScreenLoading />
      ) : (
        <></>
      )}
    </div>
  );
};
